import { stringify } from 'query-string'

/**
 * Generate a Tenant Options apply URL.
 *
 * @see https://app.tenantoptions.com.au/info/api/1.0/apply_link.html
 */
export default function tenantOptionsUrl(tenantOptionsUid, listing) {
  if (!tenantOptionsUid) return undefined

  const {
    sourceId,
    office: {
      username: orgSan,
    } = {},
  } = listing

  // Ensure all required fields are present
  if (!sourceId || !orgSan) return undefined

  const params = stringify({
    property_crm_id: sourceId,
    agent_id: orgSan,
    agent_uid: tenantOptionsUid,
  })

  return `https://app.tenantoptions.com.au/apply_link?${params}`
}
